import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";

function getYearsArray(startYear, endYear) {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
}

const currentYear = new Date().getFullYear();
const yearsArray = getYearsArray(currentYear - 10, currentYear + 8);

const quartersArray = [
  "1й квартал - Январь/Февраль/Март",
  "2й квартал - Апрель/Май/Июнь",
  "3й квартал - Июль/Август/Сентябрь",
  "4й квартал - Октябрь/Ноябрь/Декабрь",
];

const parsePeriod = (date)=>{
  const result = {
    from: {year: '', quarter: 1},
    to: {year: '', quarter: 1}
  };

  let [from, to] = date.split(" - ");
  from = from.split("/");
  if(to && to.length > 0){
    to = to.split("/");
  } else {
    to = [...from];
  }

  result["from"] = {
    year: from[0],
    quarter: from[1],
  };
  result["to"] = {
    year: to[0],
    quarter: to[1],
  };

  return result;
}

const PeriodChooser = ({ setPeriod, type, period }) => {
  React.useEffect(() => {
    let dateInfo = parsePeriod(period);
    setPeriod({
      year: dateInfo[type].year || currentYear,
      quarter: dateInfo[type].quarter || 1,
      type
    });
  }, []);

  const [year, setYear] = React.useState(currentYear);
  const [quarter, setQuarter] = React.useState(1);

  const handleYear = (event) => {
    setYear(event.target.value);
    setPeriod({
      year: event.target.value,
      quarter,
      type
    });
  };

  const handleQuarter = (event) => {
    console.log("quarter event", event.target.value);
    setQuarter(event.target.value);
    let q = quartersArray.indexOf(event.target.value) + 1;
    setPeriod({
      year,
      quarter: event.target.value,
      type
    });
  };

  // console.log(period);
  let parsed = parsePeriod(period);

  return (
    <Box
        style={{ marginBottom: "2rem" }}
        flexDirection={'row'}
        justifyContent={"flex-start"}
        alignItems="center"
        display={'flex'}
    >
      <Box
          justifyContent={"center"}
          alignItems="center"
          display={'flex'}
          width={40}
      >{type === 'from' ? 'С' : 'До'}</Box>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel htmlFor="grouped-select">Year</InputLabel>
        <Select
          defaultValue={currentYear}
          id="grouped-select"
          label="Year"
          onChange={handleYear}
          value={type === 'from' ? parsed.from.year : parsed.to.year}
        >
          {yearsArray.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 260 }}>
        <InputLabel htmlFor="grouped-select">Quarters</InputLabel>
        <Select
          onChange={handleQuarter}
          defaultValue={quartersArray[0]}
          id="grouped-select"
          label="Quarters"
          value={type === 'from' ? parsed.from.quarter : parsed.to.quarter}
        >
          {quartersArray.map((quarter, index) => (
            <MenuItem key={quarter} value={parseInt(index) + 1}>
              {quarter}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PeriodChooser;
